import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import Loading from './Loading';
import { API_KEY, BASE_URL } from "./config";

Modal.setAppElement('#root');

function SignalPartialTakeProfit({ isOpen, closeModal, symbolData }) {
  const [formData, setFormData] = useState({
    signalRequestId: symbolData.signalRequestId || null,
    symbol: symbolData.symbol || '',
    side: symbolData.side || '',
    orderType: 'market', // default value
    limitPrice: '', // to be fetched from backend
    closurePercentage: '100', // Default value
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [submissionResult, setSubmissionResult] = useState(null);

  const [showDropdown, setShowDropdown] = useState(true);

  const toggleInputType = () => {
    setShowDropdown(!showDropdown);
    if (!showDropdown) {
      // Reset to a default value when switching back to dropdown
      setFormData({ ...formData, closurePercentage: '100' });
    }
  };



  useEffect(() => {
    // Fetch the current market price for the symbol and set it as default for limitPrice
    const fetchMarketPrice = async () => {
      // Replace with your actual backend API endpoint
      const response = await fetch(`${BASE_URL}/api/bot/get/getMarkPriceBySymbol?symbol=${formData.symbol}`,
                      {
                        headers: {
                          "X-SIGNALFLY-KEY": API_KEY
                        }
                      });
      const data = await response.json();
      setFormData(prevFormData => ({ ...prevFormData, limitPrice: data.markPrice }));
    };

    if (formData.symbol) {
      fetchMarketPrice();
    }
  }, [formData.symbol]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    signalPartialTPPost(formData);
  };

  const signalPartialTPPost = (formSubmittedData) => {
    setLoading(true);
    fetch(`${BASE_URL}/api/bot/ui/post/closePartialSignalPosition`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "X-SIGNALFLY-KEY": API_KEY
      },
      body: JSON.stringify(formSubmittedData),
    })
    .then(response => {
      // Check if the response is JSON
      const contentType = response.headers.get('content-type');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      if (contentType && contentType.includes('application/json')) {
        return response.json();
      } else {
        return response.text(); // Handle non-JSON response
      }
    })
    .then(data => {
      setSubmissionResult(data); // This can be a JSON object or a text string
      setLoading(false);
    })
    .catch(error => {
      setError(error.message);
      setLoading(false);
    });
  };
  

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Signal Partial Take Profit Parameters"
      className="ReactModal__Content"
      overlayClassName="ReactModal__Overlay"
    >
      <button className="modal-close-button" onClick={closeModal}>&times;</button>
      <h2 className="page-title">Signal Partial Take Profit Parameters</h2>
      <br/>

      {loading && <Loading />}
      {error && <div>Error: {error}</div>}
      {submissionResult && <div>Result: {JSON.stringify(submissionResult)}</div>}

      {!loading && !submissionResult && (
        <form className="modal-form" onSubmit={handleSubmit}>
        <label>
          Signal Request ID:
          <input
            type="text"
            name="signalRequestId"
            value={formData.signalRequestId}
            readOnly
          />
        </label>
        <label>
          Symbol:
          <input
            type="text"
            name="symbol"
            value={formData.symbol}
            readOnly
          />
        </label>
        <label>
          Signal Side: 
          <input
            type="text"
            name="side"
            value={formData.side}
            readOnly
          />
        </label>
        <label>
          Order Type:
          <select
            name="orderType"
            value={formData.orderType}
            onChange={handleInputChange}
          >
            <option value="limit">Limit</option>
            <option value="market">Market</option>
          </select>
        </label>
        <label>
          Limit Price:
          <input
            type="text"
            name="limitPrice"
            value={formData.limitPrice}
            onChange={handleInputChange}
          />
        </label>
        <label>
          Closure Percentage:
          {showDropdown ? (
            <select
              name="closurePercentage"
              value={formData.closurePercentage}
              onChange={handleInputChange}
            >
              <option value="0">0%</option>
              <option value="10">10%</option>
              <option value="25">25%</option>
              <option value="50">50%</option>
              <option value="75">75%</option>
              <option value="100">100%</option>
            </select>
          ) : (
            <input
              type="number"
              name="closurePercentage"
              value={formData.closurePercentage}
              onChange={handleInputChange}
              max="100"
              required
            />
          )}
          <button type="button" onClick={toggleInputType}>
            {showDropdown ? 'Type Manually' : 'Select '}
          </button>
        </label>           
           
        <div className="modal-button-container">
          <button type="submit">Submit</button>
          <button type="button" onClick={closeModal}>Cancel</button>
        </div>
      </form>
      )}
    </Modal>
  );
}

export default SignalPartialTakeProfit;
